
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Senior Consultant II - SANKALP
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> Masters	in	Social	Sciences/ Public	Policy/	Social	work/ Business
Administration / Rural Management or other relevant fields
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Age limit: </h3>
              <p> Candidates should be below 45 years of age as on the date of
advertisement
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Vacancy: </h3>
              <p> 1
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 1,50,000/- to Rs. 3,00,000/- per month as consolidated pay from which standard TDS will be deducted, commensurate with experience. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 17th June 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>
		
                  <p> <span class="step_no">1</span>Minimum Ten (10) years of relevant experience and minimum of 6 years of experience in formulation, appraisal, execution/implementation, monitoring, and evaluation of policy/programme etc. etc. with Government and/or its institutions</p>
        <p> <span class="step_no">2</span>Extensive experience financial management systems & procedures including financial reports and financial statements and conversant with government accounting policies and procedures</p>
        <p> <span class="step_no">3</span>Well versed with government procedures /or extensive financial management experience in programs financed by international development organization in particular results-based programs.</p>
		        <p> <span class="step_no">4</span>Proven ability to prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc., i.e. ability to establish recognized procedures to account for fund use.</p>
	



      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
		
                  <p> <span class="step_no">1</span>Excellent writing and communication skills</p>
        <p> <span class="step_no">2</span>Strong analytical and documentation skills</p>
        <p> <span class="step_no">3</span>Experience of using computer applications including MS Office Application and other research applications</p>
			

        
        <p> <span class="step_no">4</span>Strong presentation skills and interpersonal skills</p>
		 <p> <span class="step_no">5</span>Should be able to operate in unstructured environment with minimal support.</p>
 <p> <span class="step_no">6</span>Openness to travel if required</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Manage and facilitate SANKAI.P interventions and provide support to the Ministry in planning and implementing schemes and programmes.</p>
<p><span class="step_no">2</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">3</span>Closely work with national, state institutions and agencies for Skills Acquisition and Knowledge Awareness for Livelihood Promotion.</p>
<p><span class="step_no">4</span>Support in related content and curriculum development, concept notes, analytical reports and other project and policy documents, research studies, evaluations, assessments, data collection and report development.</p>
<p><span class="step_no">5</span>Planning and coordination of innovation events, trainings, national awards, workshops, conferences, visits, and exchange programme etc.</p>
<p><span class="step_no">7</span>Design concept papers, research, and design of proposals/presentations for Key Result Areas of SANKALP</p>
<p><span class="step_no">8</span>Lead initiatives under SANKALP which involves stakeholder engagement, conceptualization, planning and monitoring and evaluation</p>

<p><span class="step_no">8</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">9</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>Annual contract with performance-based extension of contract as per project requirement</p>

           

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

 <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>

           

    
          </div>
        </div>
      </div>
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>New Delhi </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
 <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Notification</h3>
       		<p><a href="assets/pdf/SANKALP_SENIOR_CONSULTANT 2.pdf" target="_blank">Click here to download</a></p>





      </div>
    </div>
  </div>
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
